exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.active-plan {\n  box-shadow: \"0 0 0 10px #ee645a\";\n}\n", ""]);

// exports
